var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { Injectable } from '@angular/core';
import { AbstractRestService, arrayOf, RestSettings } from '@gh/core-data';
import { SharedDocsMapper } from './shared-docs.mapper';
import * as i0 from "@angular/core";
import * as i1 from "@gh/core-data";
var SupplierSharedDocsRestService = /** @class */ (function (_super) {
    __extends(SupplierSharedDocsRestService, _super);
    function SupplierSharedDocsRestService(settings) {
        var _this = _super.call(this, settings) || this;
        _this.settings = settings;
        return _this;
    }
    SupplierSharedDocsRestService.prototype.getAll = function () {
        return this.createSlicedDataSourceGet("/job/docs", arrayOf(SharedDocsMapper));
    };
    SupplierSharedDocsRestService.ɵfac = function SupplierSharedDocsRestService_Factory(t) { return new (t || SupplierSharedDocsRestService)(i0.ɵɵinject(i1.RestSettings)); };
    SupplierSharedDocsRestService.ɵprov = i0.ɵɵdefineInjectable({ token: SupplierSharedDocsRestService, factory: SupplierSharedDocsRestService.ɵfac });
    return SupplierSharedDocsRestService;
}(AbstractRestService));
export { SupplierSharedDocsRestService };
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SupplierSharedDocsRestService, [{
        type: Injectable
    }], function () { return [{ type: i1.RestSettings }]; }, null); })();
